import React, { PureComponent } from "react";

import { TitlePictureFile } from "@cm-sites-webber/components";
import collection from './images/collection.png';
import collected from "./images/collected.png";

import "./index.css"

/**
 * 渲染内容管理-标题通用图片文字显示
 */
class TitleAndPicReview extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            showCancel: false,
            showCollect: false,
            isCollect: props.item.collect
        };
    }

    componentDidMount() {

    }

    componentDidUpdate(prevProps) {
        if (prevProps.item.collect !== this.props.item.collect) {
            this.setState({
                isCollect: this.props.item.collect
            })
        }
    }

    render() {
        let { item, mediaType, collectionHandle } = this.props;
        return (
            <div className="content-management-title-pic-content">
                {item.titleCover ? <div className="content-management-title-pic-content-image">
                    {
                        this.props.mediaType=== 5 ? <div className="content-management-title-pic-image-video">
                                <TitlePictureFile style={{width: '120px', height: '81px'}} src={item.titleCover} />
                                <div className="image-video-play"></div>
                            </div> :
                            <TitlePictureFile style={{width: '120px', height: '81px'}} src={item.titleCover} />

                    }
                </div> : null}
                <div className={mediaType === 2 ? "title-content" : "content-management-title-pic-content-text"} onMouseEnter={() => {
                    if (this.state.isCollect) {
                        this.setState({
                            showCancel: true
                        });
                    } else {
                        this.setState({
                            showCollect: true
                        });
                    }
                }} onMouseLeave={() => {
                    if (this.state.isCollect) {
                        this.setState({
                            showCancel: false
                        });
                    } else {
                        this.setState({
                            showCollect: false
                        });
                    }
                }}>
                    <div className="content-management-title-pic-title-text"
                        style={{ cursor: 'pointer', width: item.titleCover ? '500px' : '670px', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}
                        title={item.title}
                        onClick={() => {
                            this.props.callBack && this.props.callBack()
                        }}
                    >{item.title}</div>
                    {mediaType === 2 && <div className="collectionDiv" onClick={() => {
                        collectionHandle();
                        this.setState({
                            isCollect: !this.state.isCollect
                        })
                    }}>
                        {
                            this.state.isCollect && <>
                                <img style={{ width: 20 }} src={collected}></img>
                                <span>
                                    {this.state.showCancel ? "取消收藏" : "已收藏"}
                                </span>
                            </>
                        }
                        {
                            !this.state.isCollect && this.state.showCollect && <>
                                <img style={{ width: 20 }} src={collection}></img>
                                <span>
                                    收藏
                                </span>
                            </>
                        }
                    </div>}
                </div>
            </div>
        )
    }
}
export default TitleAndPicReview;